import React, { Component } from 'react';
import { connect } from 'react-redux';
import { cleanComponentsTable, getProductsByCategory, mergeProductWarehouse } from 'actions/EntityActions';
import { showError } from 'actions/CommonActions';
import { formInput } from 'actions/FormActions';
import RadioInput from 'screens/components/basic/RadioInput';
import GenericTable from 'screens/components/advanced/GenericTable';
import WeightInput from 'screens/components/basic/WeightInput';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';

class JointProductsList extends Component {
    constructor(props, context) {
        super(props, context);

        this.amounts = [];
        this.products = [];
        this.weightRule = 0;
        this.weightPerUnit = 0;
    }

    componentWillMount() {
        this.props.init(this.props.preRollCategoryId, this.props.branchId);
    }

    componentWillReceiveProps(newProps)
    {
        
        if(newProps.selectedJoint !== this.props.selectedJoint )
        {
            this.props.formInput("", `${this.props.name}${this.productId}Amount`);
        }
        
    }

    getProducts = (products) => {
        let productList = [];
        const searchTerm = this.props.searchTerm;
        const that  = this; 
        products.map((product, index) => {
            if (!searchTerm || product.productName.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
                productList.push({
                    ID: product.productId,
                    Name: product.productName,
                    Quantity: parseFloat(product.totals[0].quantity).toFixed(1),
                    Price: product.price,
                    Amount: <TextInput name={`${this.props.name}${product.productId}Amount`}
                        underlineShow={false}
                        hintText={LOOKUP.transferProduct.amount.hintText}
                        className="table-field"
                        ref={(input) => this.amounts[index] = input}
                        data-productId={product.productId}
                        type="number" fullWidth={true}
                        label="Amount"
                        min={0}
                        onInput={(e) => this.validateTableComponents(e, product)}
                        max={this.weightRule}
                        disabled={this.isPrePackSelected(product)}
                         />
                });
            }
        });

        this.products = productList;
        return productList;
    };

    transferJoint = () => {
        const p = this.props;
        let jointProductId = parseInt(p.selectedJoint);
        let productsFrom = [];
        let isThereAmount = false;
        for (let index = 0; index < this.amounts.length; index++) {
            let item = this.amounts[index];
            if (item && item.stateProps && item.stateProps.value && item.props["data-productId"]) {
                if (item.stateProps.value && item.stateProps.value !== "") {
                    if (parseFloat(item.stateProps.value) > 0) {
                        productsFrom.push({
                            idProductFrom: parseInt(item.props["data-productId"]),
                            amount: parseFloat((item.stateProps.value * this.weightPerUnit))
                        });
                    }
                }
                let parentName = this.props.name;
                let childName = parseInt(item.props["data-productId"]);
                this.props.cleanComp(parentName, childName);
            }
        }


        if (jointProductId) {
            if (productsFrom.length > 0) {
                const model = {
                    idJointProduct: jointProductId,
                    branchId: p.branchId,
                    productsFrom: productsFrom
                };

                this.props.mergeProduct(model);
                this.props.onCancel();
                this.props.selectedRows.forEach((item) => {
                    this.props.formInput(false, `Stock${parseInt(item) + 1}Checkbox`);
                });
                this.props.formInput(null, 'warehouseStockListTableSelectedRows');
            } else {
                this.props.showError("Please, input amount on the selected products!");
            }
        } else {
            this.props.showError("Please, choose one of options to create the roller joint!");
        }
    }

    /**
     * 
     * @param {object} product - Product that the joint is going to happen 
     */
    calculateQuantityPerWeight(product)
    {   
        
        if(this.props.selectedJoint)
        {
            const selectedJoint = this.props.selectedJoint;
            let jointRule = this.props.productByCategory.filter( (p) => p.id == selectedJoint)[0];
            this.weightPerUnit = jointRule.weightPerUnit;
            this.weightRule = parseInt(Math.floor(product.quantity / this.weightPerUnit));
            this.productId = product.productId;
        }

    }
    /**
     * Function to check if the Prepack is Selected, otherwise the Amount will be set to disabled
     */
    isPrePackSelected(product)
    {
        if(this.props.selectedJoint === undefined)
        {
            return true;
        }
        this.calculateQuantityPerWeight(product);
        return false;
    }

    /**
     * function that checks the maximum value and change the value in each number
     */
    validateTableComponents = (event, product) => {
        let p = Math.max(0, parseFloat(event.target.value)).toString().slice(0, 6);
        if (p <= this.weightRule) {
            event.target.value = p;
        } else if (p > this.weightRule) {
            event.target.value = this.weightRule;
        } else {

            event.target.value = p;
        }
    }

    render() {

        const p = this.props;
        const items = p.productByCategory.map((item) => {
            return {
                value: item.id.toString(),
                text: item.name
            };
        });

        return (
            <div>
                <div className="row">
                    <div className="col-lg-12">
                        <p>
                            Select the <b>Joint/Pre-Roll</b> product from the following list.
                            Only those flowers that have a non-empty amount will be transferred to the sale's warehouse under selected Joint/Pre-Roll.
                        </p>
                        <RadioInput 
                            groupName={p.name + "SelectedJointProduct"}
                            options={items}
                        />
                    </div>
                </div>
                {(this.props.selectedJoint) ? 
                    <div className="row">
                    <div className="col-lg-12">
                        <p>
                            This Joint/Pre-Roll uses <strong> {this.weightPerUnit}g </strong> per unit.
                            <br />
                            Enter how many units you want to transfer to the store in the table bellow.
                        </p>
                        <GenericTable
                            compName="jointProductsList"
                            columns={LOOKUP.transferProduct.tableColumnsProductJoint}
                            rows={this.getProducts(p.selectedProducts || [])}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            multiSelectable={false}
                            enableSelectAll={false}
                            stripedRows={true}
                            selectable={false} />
                    </div>
                </div> 
                    : 
                    <div className="row">
                        <div className="col-lg-12">
                            <p className="text-warning text-center">
                                Select the Joint/Pre-Roll Above
                            </p>
                        </div>
                    </div>
                }
                <br />
                <div className="row">
                    <div className="col-lg-12">
                        <Button
                            name="trasferJointButton"
                            className="pull-right"
                            label="Create"
                            primary={true}
                            onTouchTap={() => this.transferJoint()} />
                        <Button
                            name="buttonCancel"
                            type="Button"
                            className="corner_X"
                            onTouchTap={() => p.onCancel()} />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        productByCategory: state.entity.productByCategory,
        selectedJoint: state.form[ownProps.name + "SelectedJointProduct"],
        preRollCategoryId: state.common.applicationSettings.preRollCategoryId,
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: (typeId, branchId) => dispatch(getProductsByCategory(typeId, branchId)),
        mergeProduct: (model) => dispatch(mergeProductWarehouse(model)),
        cleanComp: (parentCompName, childCompName) => dispatch(cleanComponentsTable(parentCompName, childCompName)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(JointProductsList);